import { Divider, Flex, Text } from "@chakra-ui/react"
import { SidebarItemBtn } from "component/sidebar/SidebarItemBtn"
import { configuration, Route } from "configuration"
import { useSidebarContext } from "context/sidebarContext"
import { UserContext } from "context/userContext"
import { UserModel } from "model/UserModel"
import { FC, Fragment, useContext } from "react"
import { isRouteAllowed } from "util/route"

const routes = configuration.sidebar.routes

export const SidebarItemsList: FC = () => {
  const { isCollapsed } = useSidebarContext()
  const user = useContext<UserModel>(UserContext)

  // Пункты без доступа (нет режима у арендатора, клиент "только маппинг")
  // видны, но заблокированы — с замком и подсказкой, почему не нажимаются
  const isLocked = (route: Route) => !isRouteAllowed(route, user)

  return (
    <Flex w="full" direction="column" gap={1}>
      {routes.map((route, index) => {
        // Блоки меню — группы ("Маппинг", "Ассистенты") и отдельные пункты
        // после группы — разделены линией. Подпись группы в свёрнутой панели
        // не видна, линия остаётся
        const isNewBlock =
          index > 0 && (!!route.subRoutes || !!routes[index - 1].subRoutes)
        const divider = isNewBlock && <Divider my={2} borderColor="gray.200" />

        if (!route.subRoutes) {
          return (
            <Fragment key={index}>
              {divider}
              <SidebarItemBtn route={route} isLocked={isLocked(route)} />
            </Fragment>
          )
        }

        // Группа — подпись и пункты под ней, без аккордеона: пунктов мало,
        // лишний клик ради раскрытия не нужен
        return (
          <Fragment key={index}>
            {divider}

            {!isCollapsed && (
              <Text
                px={3}
                pt={1}
                pb={1}
                fontSize="xs"
                fontWeight="semibold"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="wider"
              >
                {route.title}
              </Text>
            )}

            {route.subRoutes.map((subRoute, subIndex) => (
              <SidebarItemBtn
                key={subIndex}
                route={subRoute}
                isLocked={isLocked(subRoute)}
              />
            ))}
          </Fragment>
        )
      })}
    </Flex>
  )
}
